import styled, { css } from 'styled-components';

export const Container = styled.div`
  position: relative;
`;

export const CalendarWrapper = styled.div`
  padding: 12px;
  display: flex;
  gap: 16px;
  align-items: center;
  background: #ffffff;
  border: 1px solid #cbcbcb;
  border-radius: 5px;
  min-width: 273px;
  cursor: pointer;

  @media (max-width: 768px) {
    padding: 8px 9px;
    max-width: 172px;
    width: 172px;
    min-width: unset;
    flex-direction: row-reverse;
    justify-content: space-between;
  }
`;

export const CalendarIconWrapper = styled.div``;

export const CalendarText = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #636363;

  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 18px;
  }
`;

export const CalendarContainer = styled.div`
  position: absolute;
  background: #ffff;
  width: max-content;
  top: 62px;
  right: 0;
  border-radius: 4px;
  padding: 16px;
  border: 1px solid #b6c1ca;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
    background: #eff0f0;
    z-index: 9999;
    border-radius: unset;
    border: unset;
    padding: 12px;
    justify-content: flex-start;
  }
`;

export const CalendarBody = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 32px;
    justify-content: center;
    align-items: normal;
  }
`;

export const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    justify-content: center;
  }
`;

type OptionProps = {
  active?: boolean;
};

export const Option = styled.div<OptionProps>`
  cursor: pointer;
  padding: 6px 12px;
  background: #f6f7f9;
  border-radius: 8px;

  ${({ active }) =>
    active &&
    css`
      background: #e0edff;
      border: 1px solid #0b29fb;
    `}

  @media (max-width: 768px) {
    padding: 3px 6px;
    background: transparent;
    border: 1px solid #cbcbcb;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;

    ${({ active }) =>
      active &&
      css`
        background: transparent;
        border: 1px solid #0b29fb;
      `}
  }
`;

export const OptionText = styled.span<OptionProps>`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #3d3d3d;

  @media (max-width: 768px) {
    font-size: 13px;
    line-height: 18px;

    ${({ active }) =>
      active &&
      css`
        color: #0b29fb;
      `}
  }
`;

export const CalendarHeader = styled.div``;

export const CalendarContent = styled.div`
  flex: 1;
  border-left: 1px solid #dce0e5;
  margin-left: 16px;
  padding-left: 16px;

  @media (max-width: 768px) {
    border-left: unset;
    margin-left: unset;
    padding-left: unset;

    background: #ffffff;
    padding: 16px;
    border: 1px solid #cbcbcb;
    border-radius: 8px;
  }
`;

export const CalendarFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #dce0e5;
  margin-top: 8px;
  padding-top: 12px;

  @media (max-width: 768px) {
    justify-content: flex-end;
    border-top: unset;
  }
`;

export const CalendarButtonCancel = styled.div`
  background: #ffff;
  border: 1px solid #dce0e5;
  border-radius: 8px;
  padding: 8px;
  cursor: pointer;
  font-family: 'Mangueira Medium', sans-serif;
  font-weight: 500;
  font-size: 15px;
  line-height: 21px;
  color: #3d3d3d;
`;

export const CalendarButtonConfirm = styled(CalendarButtonCancel)`
  background: #0b29fb;
  color: #ffff;
  border: 1px solid #0b29fb;
`;

export const RangeData = styled.div`
  @media (max-width: 768px) {
    border-top: 1px solid #dce0e5;
    margin-top: 12px;
    padding-top: 12px;
  }
`;

export const RangeDataText = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 15px;
  line-height: 21px;
  color: #3d3d3d;
  text-transform: capitalize;
`;

export const ButtonsFooterWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const MobileTitleWrapper = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    margin-bottom: 16px;
  }
`;

export const MobileTitle = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #3d3d3d;
`;

export const CloseIcon = styled(MobileTitle)`
  cursor: pointer;
`;
